import { createAction, props } from "@ngrx/store";
import { Release } from "../../models/release-fields";

// **Load Releases**
export const loadRelease = createAction(
  "[Release] Load Release",
  props<{ projectId: string }>()
);

export const loadReleaseSuccess = createAction(
  "[Release] Load Release Success",
  props<{ releaseList: Release[] }>()
);

export const loadReleaseFailure = createAction(
  "[Release] Load Release Failure",
  props<{ error: any }>()
);

// **Get Release by ID**
export const getReleaseById = createAction(
  "[Release] Get Release",
  props<{ projectId: string, releaseId:string }>()
);


export const getReleaseByIdSuccess = createAction(
  "[Release] Load Release Success",
  props<{ release: Release}>()
);

// **Create Release**
export const createRelease = createAction(
  "[Release] Create Release",
  props<{ projectId:string, release: Release }>()
);

export const createReleaseSuccess = createAction(
  "[Release] Create Release Success",
  props<{ release: Release }>()
);

export const createReleaseFailure = createAction(
  "[Release] Create Release Failure",
  props<{ error: any }>()
);

// **Update Release**
export const updateRelease = createAction(
  "[Release] Update Release",
  props<{  projectId:string, releaseId:string, release: Release }>()
);

export const updateReleaseSuccess = createAction(
  "[Release] Update Release Success",
  props<{  release: any }>()
);

export const updateReleaseFailure = createAction(
  "[Release] Update Release Failure",
  props<{ error: any }>()
);

// **Delete Release**
export const removeRelease = createAction(
  "[Release] Remove Release",
  props<{  projectId:string, releaseIdList: any }>()
);

export const removeReleaseSuccess = createAction(
  "[Release] Remove Release Success",
  props<{ releaseIdList: any }>()
);

export const removeReleaseFailure = createAction(
  "[Release] Remove Release Failure",
  props<{ error: any }>()
);

export const ReleaseActions = {
  getReleaseById,
  getReleaseByIdSuccess,
  loadRelease,
  loadReleaseSuccess,
  loadReleaseFailure,
  createRelease,
  createReleaseSuccess,
  createReleaseFailure,
  updateRelease,
  updateReleaseSuccess,
  updateReleaseFailure,
  removeRelease,
  removeReleaseSuccess,
  removeReleaseFailure,
};
